export default __webpack_public_path__ + "static/media/iosButton.d282db4e.svg";